export const url = {
  // 公共字典url
  GET_DICTIONARY: '/auth/dictionaries/findByParentId',

  allList: '/manage/formulation/findList',
  myList: '/manage/formulation/findHisList',
  category: '/auth/public/get_goodsMarketCategory',
  subCategory: '/auth/public/get_goodsSubCategory',
  subCategories: '/auth/public/get_goodsSubCategories',
  findInci: '/app/trade/inci/findInci',
  searchUserList: '/auth/user/searchUserList',
  aspects: '/auth/public/get_goodsAspects',
  form: '/auth/public/get_goodsForms',
  claim: '/auth/public/get_goodsClaim',
  PA: '/auth/public/get_goodsPA',
  SPF: '/auth/public/get_goodsSPF',
  country: '/auth/public/get_basfCountry',
  approverList: '/auth/user/searchApproveUserList', // 获取审核列表
  specificGroup: '/auth/public/get_goodsSpecificGroup',
  applicationArea: '/auth/public/get_goodsApplicationArea',
  add: '/manage/formulation/saveHis',
  judge: '/manage/formulation/approval',
  withdraw: '/manage/formulation/withdraw',
  myDetail: '/manage/formulation/find',
  allDetail: '/manage/formulation/find',
  addDetail: '/manage/formulation/save',
  update: '/manage/formulation/updateById',
  pending: '/manage/formulation/pendingCount',
  recommendProduct: '/auth/formulation/recommendProduct',
  pdfParsing: '/manage/formulation/pdfParsing',
  updateStatus: '/manage/formulation/updateStatus',

  relationList: '/manage/formulation/findFormulationTradeList',
  relationDetail: '/manage/formulation/findFormulationTrade',
  updateRelation: '/manage/formulation/updateFormulationTrade',

  tagList: '/auth/public/get_formulationTags',
  tradeNameList: '/auth/formulation/get_basfFormulationTrade',
  INCIList: '/auth/public/get_basfInci',
  formulationList: '/auth/formulation/findList',
  formulationDetail: '/auth/formulation/find',
  similarFormulation: '/auth/formulation/similarFormulation',
  keyBasfProduct: '/auth/formulation/keyBasfProduct',
  getLastApprovalDate: '/manage/formulation/getLastApprovalDate',
  relateConcept: '/auth/formulation/relateConcept',
  similarFormulationMap: '/auth/formulation/similarFormulationMap',
  getAllInciFilter: '/auth/trade/inci/allInciFilter',
  editUploadFormulation: '/auth/formulation/edit',
  getUploadFormulationCount: '/auth/formulation/myFormulationCount',
  getLastUpdateTime: '/auth/formulation/lastUpdateTime',
  getPhaseList: '/auth/formulation/phaseList',
  download: '/auth/public/download_file',
  recommendProductForList: '/auth/formulation/benchmarkProducts',
  delete: '/auth/formulation/delete'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/formulation.js